import "@core/scss/template/libs/vuetify/index.scss";
import { createVuetify } from "vuetify";
import { VBtn } from "vuetify/components/VBtn";
import "vuetify/styles";
import defaults from "./defaults";
import { icons } from "./icons";
import createTheme from "./theme";

export function createVuetifyWithTheme(themePrimaryColor?: string, themePrimaryColorDark?: string) {
  const theme = createTheme(themePrimaryColor, themePrimaryColorDark);
  return createVuetify({
    aliases: {
      IconBtn: VBtn,
    },
    defaults,
    icons,
    theme,
  });
}
